import { ReactElement } from "react";
import styled from "styled-components";
import logo from "../../assets/logo-branco.webp";

const Container = styled.header`
  align-items: center;
  background: #084f43;
  display: flex;
  padding: 16px 60px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 16px 24px;
  }
`;

const Logo = styled.img`
  height: auto;
  width: 140px;
`;

export function HeaderSuccess(): ReactElement {
  return (
    <Container>
      <Logo src={logo} alt="Cartão de TODOS" />
    </Container>
  );
}
